<template>
    <div class="block-keyword-query-render">
        <h5 class="ai-common-suggestion-board__block-title">
            <PtIcon
                class="ai-common-suggestion-field-item__description-icon"
                icon="GptAvatar"
            />
            <span>
                {{ $t('smartSearch.keywordQueryTitle', { keyword }) }}
            </span>
        </h5>
        <div
            class="block-keyword-query__main"
            @mousedown="handleClick"
        >
            <div
                v-for="item in items"
                :key="item.index"
                class="block-keyword-query__item"
            >
                <span class="block-keyword-query__item-logic">OR</span>
                <span class="block-keyword-query__item-keyword">{{ item.value }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/GptAvatar.svg';
import { messages } from '../../locales';

export default {
    name: 'BlockKeywordQuery',
    i18n: {
        fallbackLocale: 'cn',
        messages,
    },
    components: {
        PtIcon,
    },
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        keyword: {
            type: String,
            default: '',
        },
    },
    methods: {
        handleClick(e) {
            const query = `OR ${this.items.map((item) => `"${item.value}"`).join(' OR ')}`;
            this.$emit('select', query);
            e.preventDefault();
            e.stopPropagation();
        },
    },
};

</script>
